window.addEventListener('load', function() {
  
    function initializeFlickityForAll() {
              document.querySelectorAll('.nosto-list-item .colorVariantCount').forEach(element => {
            if (!element.hasAttribute('data-count-updated')) {
              element.setAttribute('data-count-updated', 'true'); // Mark to prevent duplicate processing
              const value = element.textContent || "";
              const colorCount = value.split('|').length;
              if (colorCount > 1){ 
                element.textContent = `Colors +${colorCount - 1}`;
                element.style.opacity = 1;
              } else {
                element.textContent = ``;
              }
            }
        });
        var nostoLists = document.querySelectorAll('.nosto-list');
        nostoLists.forEach(function(nostoList, index) {
            var uniqueClassName = 'nosto-list-' + index;
            nostoList.classList.add(uniqueClassName);
            var flkty = new Flickity('.' + uniqueClassName, {
                cellAlign: 'left',
                contain: true
            });
        });
    }

    function wrapDivsWithAnchor() {
        const nostoContainers = document.querySelectorAll('.nosto-image-container');
        nostoContainers.forEach(container => {
            const productUrl = container.getAttribute('product-url');
            const anchor = document.createElement('a');
            anchor.setAttribute('href', productUrl);
            container.parentNode.insertBefore(anchor, container);
            anchor.appendChild(container);
        });
    }

    function handleWishListClick(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        const wishList = evt.target;
        const product = wishList.closest('.nosto-list-item');
        const wishlistbtn = wishList.closest('.wishlist');
       
        if (!product) return;

        const wishListObject = {
            "epi": product.getAttribute('data-variant-id'),
            "du": product.getAttribute('data-product-url'),
            "empi": product.getAttribute('data-product-id'),
            "iu": product.getAttribute('data-product-image-url')
        };

        const isSaved = wishList.classList.toggle('is-saved');
        const iconswitch = wishlistbtn.classList.toggle('is-saved');
        const action = isSaved ? 'addToWishList' : 'removeFromWishList';

        window._swat[action](wishListObject, function(r) {
            console.log('wishlist', isSaved ? 'added' : 'removed', r);
            theme.updateWishList();
        });
    }
  
    function checkNostoList() {
        var nostoList = document.querySelector('.nosto-list');
        if (!nostoList) {
            setTimeout(checkNostoList, 100);
            return;
        }

        const wishlistButtons = document.querySelectorAll('.wishlist');
        if (!wishlistButtons.length) return;

        wishlistButtons.forEach(function(button) {
            const empi = button.getAttribute('data-empi');
            const epi = button.getAttribute('data-epi');
            if (empi || epi) {

              const matching_arr = window.myWishList ? window.myWishList.filter(i => i.empi == empi || i.epi == epi) : [];
              if (matching_arr.length) button.classList.add('is-saved');
            }
            button.addEventListener('click', handleWishListClick);
        });
const cartDrawerButton = document.querySelector(".js-drawer-open-cart");
      
if (cartDrawerButton) {
    cartDrawerButton.addEventListener('click', () => {
        // Use MutationObserver to wait for .nosto-cart-el elements to load
        const nostoObserver = new MutationObserver((mutationRecords, nostoObserverInstance) => {
            const nostoCartElements = document.querySelectorAll('.nosto-cart-el');

            if (nostoCartElements.length > 0) {
                nostoObserverInstance.disconnect(); // Stop observing

                setTimeout(() => {
                    nostoCartElements.forEach(nostoCartElement => {
                        const upsellProductItems = nostoCartElement.querySelectorAll('.nosto-list-item');
                        upsellProductItems.forEach(upsellProduct => {
                            const upsellAddToCartButton = upsellProduct.querySelector('.atc-cart-nosto');
                            if (!upsellAddToCartButton) return;
                            
                            upsellAddToCartButton.addEventListener('click', function (event) {
                                if (upsellAddToCartButton.classList.contains('already-in-cart')) {
                                    cartDrawerButton.click();
                                }
                                event.stopPropagation();
                                event.preventDefault();
                                theme.SizeDrawer.open(event, upsellProduct.getAttribute('data-product-handle'));
                            });
                        });
                    });
                }, 700);
            }
        });

        // Start observing the DOM for changes
        nostoObserver.observe(document.body, { childList: true, subtree: true });
    });
}


        initializeFlickityForAll();
        wrapDivsWithAnchor();
        initializeSliderWhenDrawerIsOpen();
    }
    
function initializeSliderWhenDrawerIsOpen() {
    var cartDrawer = document.getElementById('CartDrawer');
    var isOpen = cartDrawer.classList.contains('drawer--is-open');

    document.querySelectorAll(".nosto-cart-el .nosto-list").forEach(slider => {
        var existingFlkty = Flickity.data(slider);

        if (isOpen && !existingFlkty) {
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: false
            });
        } else if (!isOpen && existingFlkty) {
            existingFlkty.destroy();
        }
    });
}

     
    function handleMutations(mutationsList, observer) {
      
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList') {

                initializeSliderWhenDrawerIsOpen();
            }
        });
    }
    
    var observerOptions = {
        childList: true,
        subtree: true
    };
    
    var observer = new MutationObserver(handleMutations);
    
    var cartDrawer = document.getElementById('CartDrawer');
    observer.observe(cartDrawer, observerOptions);
    initializeSliderWhenDrawerIsOpen();
    checkNostoList();
  
    const ccartButton = document.querySelector(".js-drawer-open-cart");
    if (ccartButton) {
        ccartButton.addEventListener('click', function() {
          theme.cart.getCart().then((cart) => {
            document.getElementById('cart-item-count').textContent = cart.item_count; 
          });
            // Initialize the slider when the cart drawer is opened
            initializeSliderWhenDrawerIsOpen();
        });
    }
});
